import ButtonInnerContainer from '@root/joinroot.com/src/components/buttons/button-inner-container';
import Colors from '@root/joinroot.com/src/utils/colors';
import Input, { TextTypes } from '@root/core/src/components/input';
import LinkButton from '@root/joinroot.com/src/components/buttons/link-button';
import LinkButtonModel from '@root/joinroot.com/src/models/link-button';
import Select from '@root/core/src/components/select';
import environment from '@root/core/src/utils/environment';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { H5 } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';
import { useState } from '@root/vendor/react';

const options = [
  {
    value: 'currently-insured-needs-savings',
    label: 'Currently insured, needs savings',
  },
  {
    value: 'currently-insured-just-curious',
    label: 'Currently insured, just curious',
  },
  {
    value: 'uninsured-need-coverage',
    label: 'Uninsured, need coverage',
  },
  {
    value: 'uninsured-just-curious',
    label: 'Uninsured, just curious',
  },
];

export default function AffiliateMarketingZipCodeForm() {
  const [zipCode, setZipCode] = useState('');
  const [option, setOption] = useState('');
  const { trackClick } = useAnalytics('AFFILIATE_MARKETING_ZIP_CODE_FORM');

  function handleContinueClick() {
    trackClick('CONTINUE', {
      zipCode,
      option,
    });
  }

  return (
    <div css={styles.container}>
      <H5 css={styles.fieldText}>{'What\'s your ZIP Code?'}</H5>
      <Input
        inputStyle={styles.inputStyle}
        inputType={TextTypes.NUMBER}
        label={'Enter Your ZIP'}
        onChange={setZipCode}
        value={zipCode}
        wrapperStyle={styles.inputWrapperStyle}
      />
      <H5 css={styles.fieldText}>{'How can we help you?'}</H5>
      <Select
        inputId={'how-can-we-help-you'}
        inputName={'how-can-we-help-you'}
        onChange={setOption}
        options={options}
        placeholder={'Please select'}
        selectedValue={option}
      />
      <LinkButton
        buttonStyles={styles.continueButton}
        isTabbable={true}
        onClick={handleContinueClick}
        to={environment.quoteAppBaseUrl}
        type={LinkButtonModel.types.PRIMARY}
      >
        <ButtonInnerContainer>
          {'Continue'}
        </ButtonInnerContainer>
      </LinkButton>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 40,
    backgroundColor: Colors.grayLight(),
    borderRadius: 10,
    border: `1px solid ${Colors.grayLighter()}`,
    padding: 25,
    maxWidth: 500,
    width: '100%',
  },
  fieldText: {
    textAlign: 'left',
    marginBottom: 10,
    fontWeight: 'bold',
  },
  inputWrapperStyle: {
    marginBottom: 20,
  },
  inputStyle: {
    border: `1px solid ${Colors.grayLighter()}`,
    borderRadius: 6,

    '&:focus': {
      border: `1px solid ${Colors.grayLighter()}`,
    },
  },
  continueButton: {
    marginTop: 30,
  },
});
